import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppSettingsActions } from 'src/app/state/actions/app-settings.actions';

export type DevicePermission = 'camera' | 'geolocation' | 'microphone';

@Injectable({
	providedIn: 'root',
})
export class DevicePermissionsService {
	constructor(private store: Store) {}

	getPermission(permissionStatus: DevicePermission): Observable<string> {
		return new Observable(observable => {
			navigator.permissions
				.query({
					name: permissionStatus as PermissionName,
				})
				.then(
					(result: PermissionStatus) => {
						const permissionState = result.state;
						observable.next(permissionState);
						this.listenChangesOnGeolocationPermission(result, permissionStatus);
						observable.complete();
					},
					error => {
						observable.error(error);
						observable.complete();
					}
				);
		});
	}

	private listenChangesOnGeolocationPermission(
		result: PermissionStatus,
		permissionStatus: DevicePermission
	) {
		result.addEventListener('change', () => {
			const { state } = result as PermissionStatus;
			if (permissionStatus === 'geolocation') {
				this.store.dispatch(
					AppSettingsActions.addIsGeolocationEnabled({
						isGeolocationEnabled: state === 'granted',
					})
				);
			}
		});
	}
}
